/* 🤖 this file was generated by svg-to-ts */
export const IconBigMediumKalender: {
    name: 'big-medium-kalender';
    data: string;
} = {
    name: 'big-medium-kalender',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><rect width="18" height="18" x="25" y="57" rx="4"/><path d="M116 11h-15a9 9 0 0 0-18 0H45a9 9 0 0 0-18 0H12a9 9 0 0 0-9 9v100a5 5 0 0 0 5 5h112a5 5 0 0 0 5-5V20a9 9 0 0 0-9-9M13 21h14v2a9 9 0 0 0 18 0v-2h38v2a9 9 0 0 0 18 0v-2h14v14H13zm102 94H13V45h102z"/><rect width="18" height="18" x="55" y="57" rx="4"/><rect width="18" height="18" x="85" y="57" rx="4"/><rect width="18" height="18" x="25" y="87" rx="4"/><rect width="18" height="18" x="55" y="87" rx="4"/><rect width="18" height="18" x="85" y="87" rx="4"/></svg>`,
};
